<template>
    <a-modal title="选择菜单图标" v-model="visible"   :maskClosable="false"  @ok="handle(true)" @cancel="handle">
      <div class="icon-wapper">
        <a-icon :class="{'selected': selectIndex === index}" v-for="(icon, index) in iconList" :key="index" class="icon" :type="icon" @click="chooseIcon(index)"></a-icon>
      </div>
    </a-modal>
</template>
<script>
import {iconList} from '../../../../../utils/commonDef'
export default {
  data() {
    return {
      iconList,
      selectIndex: 0
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },  
  },
  methods: {
    handle(flag) {
      if (flag) {
        this.$emit('getChosenIcon', flag ? iconList[this.selectIndex]: '')
      }
    },
    chooseIcon(index) {
      this.selectIndex = index
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body{
  display: flex;
  flex-wrap:  wrap;
}
.icon-wapper{
  flex-wrap:  wrap;
  .icon{
    font-size: 20px;
    padding:20px;
    cursor: pointer;
  }
  .selected{
    background:#3a7fbc;
  }
}
</style>